module.exports = __webpack_public_path__ + "static/media/fit-preto.b8a32bd7.webp";